export const TYPES = {
  AUTH: "auth",
  AUTH_TOAST: "auth-toast",
  HOME: "home",
  USER: "user",
  STANDUP: "standup",
  NEW_STANDUP: "new-standup"
}
